import { DecimalConfig } from '../configs/decimal.config';

const format = (
  value :number | string,
  places :number = DecimalConfig.defaultPlaces,
) :string => {
  if (value == null) return ''; // keep nullish values empty [calvin]

  if (value.toString() === '.') {
    return '0.';
  }

  const numericValue = handleInput(value);

  if (typeof numericValue === 'number') {
    const formatted = numericValue.toFixed(places);

    return formatted.replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1');
  } else {
    return numericValue;
  }
};

const handleInput = (value :any) :any => {
  // Check if the input is "0." or a similar pattern like "0.000"
  if (/^0\.\d*0$/.test(value) || value === '0.') {
    // If the value is "0." or has multiple zeros after it, return the value as is
    return parseFloat(value);
  }

  // Attempt to parse the value into a float
  const parsedValue = parseFloat(value);
  if (isNaN(parsedValue)) {
    // If the value cannot be parsed into a number, default to zero or keep the input unchanged
    return 0;
  }

  return parsedValue; // Return the parsed value if it's a valid float
};

export const DecimalPlacesUtils = {
  format,
};
